export type OrderEmailClickTarget =
  | 'factory_reset'
  | 'how_to_pack_and_ship'
  | 'electronic_verification_service'

type OrderEmailClickEventArgs = {
  target: OrderEmailClickTarget
  transactionId?: string
  emailCode?: string
  details?: string
}

type OrderEmailClickEventExtra = {
  target: OrderEmailClickTarget
  transaction_id?: string
  email_code?: string
  details?: string
}

export const orderEmailClickEvent = (args: OrderEmailClickEventArgs) => {
  const extra: OrderEmailClickEventExtra = {
    target: args.target,
    transaction_id: args.transactionId,
    email_code: args.emailCode,
    details: args.details,
  }

  return {
    event: 'order_email.click',
    extra,
  }
}
